import { createFeature, createReducer, on } from '@ngrx/store';
import { formsActions } from './forms.action';
import { Errors, Field } from './forms.interface';

export interface NgrxFormsState {
  data: any;
  structure: Field[];
  valid: boolean;
  errors: Errors;
  touched: boolean;
  dirty: boolean;
}

export const ngrxFormsInitialState: NgrxFormsState = {
  data: {},
  structure: [],
  valid: true,
  errors: {},
  touched: false,
  dirty: false,
};

export const ngrxFormsFeature = createFeature({
  name: 'ngrxForms',
  reducer: createReducer(
    ngrxFormsInitialState,
    on(formsActions.setData, (state, action) => ({
      ...state,
      data: action.data,
    })),
    on(formsActions.updateData, (state, action) => {
      const data = { ...state.data, ...action.data };
      return { ...state, data, touched: true };
    }),
    on(formsActions.setStructure, (state, action) => ({
      ...state,
      structure: action.structure.slice(0),
    })),
    on(formsActions.setErrors, (state, action) => ({
      ...state,
      errors: action.errors,
    })),
    on(formsActions.initializeErrors, (state) => ({ ...state, errors: {} })),
    on(formsActions.initializeForm, () => ngrxFormsInitialState),
    on(formsActions.resetForm, () => ({
      ...ngrxFormsInitialState,
      touched: false,
    })),
    on(formsActions.revertChanges, (state) => {
      return {
        ...state,
        data: {
          ...state.data, // just let the ngrx store know the data object is different than the previous one
        },
        touched: false,
      };
    }),
    on(formsActions.markAsDirty, (state) => ({
      ...state,
      dirty: true,
    })),
    on(formsActions.markAsPristine, (state) => ({
      ...state,
      dirty: false,
    })),
    on(formsActions.markAsTouched, (state) => ({
      ...state,
      touched: true,
    })),
    on(formsActions.markAsUntouched, (state) => ({
      ...state,
      touched: false,
    })),
  ),
});
